import styled from "styled-components";

export const AssignmentModalTaskCommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .title,
  .subtitle {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .title {
    color: ${({ theme }) => theme.console.sidebar.titleColor} !important;
    letter-spacing: 0.025rem;
    font: 600 0.875rem/1.313rem "Inter";
  }

  .subtitle {
    font: 400 0.813rem/1.219rem "Inter";
    color: ${({ theme }) =>
      theme.console.sidebar.subSectionTitleColor} !important;

    margin-bottom: 0;
  }
`;

export const AssignmentModalTaskCommentsContent = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;
